import { action, observable, runInAction } from 'mobx';

import agent from '../api/agent';
import { IOption } from '../models/option';
import { ITicketPrice } from '../models/ticketPrice';
import { RootStore } from './rootStore';

export default class TicketPriceStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable ticketPriceOptions: IOption[] = [];
  @observable ticketPriceRegistry = new Map();
  @observable loading = false;

  @action loadTicketPrices = async (
    agentId: string,
    startDate: string,
    mdTdTicketType: string
  ) => {
    this.loading = true;
    try {
      const ticketPrices = await agent.TicketPrices.list(
        agentId,
        startDate,
        mdTdTicketType
      );
      runInAction('loading TicketPrices', () => {
        ticketPrices.forEach((ticketPrice) => {
          this.ticketPriceRegistry.set(ticketPrice.ticketUid, ticketPrice);
        });
        this.ticketPriceOptions = ticketPrices.map((item: ITicketPrice) => ({
          key: item.ticketUid,
          value: item.ticketDisplayName,
          text: item.ticketDisplayName,
        }));
        this.loading = false;
      });
    } catch (error) {
      runInAction('load TicketPrices error', () => {
        this.loading = false;
      });
    }
  };

  @action loadTicketPrice = (key: string) => {
    return this.ticketPriceRegistry.get(key);
  };
}
